module.exports = __webpack_public_path__ + "static/img/AlPaton.3a704eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AlPaton.jpg
// module id = SB2Q
// module chunks = 0